import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
    //state
    genericProducts: [],
    productConfig: []
};

// thunk
export const createGenericProducts = createAsyncThunk(
    "productConfig/createGenericProducts",
    async (payload) => {
        try {
            const response = await api.productConfig.createGenericProducts(payload);
            if (response.status === 201) {
                return response.data;
            } else {
                throw new Error(`Unexpected status code: ${response.status}`);
            }
        } catch (error) {
            console.error("API call failed:", error);
            throw error;
        }
    }
);

export const updateGenericProducts = createAsyncThunk(
    "productConfig/updateGenericProducts",
    async (payload) => {
        try {
            const response = await api.productConfig.updateGenericProducts(payload);
            if (response.status === 201) {
                return response.data;
            } else {
                throw new Error(`Unexpected status code: ${response.status}`);
            }
        } catch (error) {
            console.error("API call failed:", error);
            throw error;
        }
    }
);


export const getGenericProducts = createAsyncThunk(
    "productConfig/getGenericProducts",
    async (payload) => {
        try {
            const response = await api.productConfig.getGenericProducts(payload);
            if (response.status === 201) {
                return response.data;
            } else {
                throw new Error(`Unexpected status code: ${response.status}`);
            }
        } catch (error) {
            console.error("API call failed:", error);
            throw error;
        }
    }
);

export const getProductConfig = createAsyncThunk(
    "productConfig/getProductConfig",
    async (payload) => {
        try {
            const response = await api.productConfig.getProductConfig(payload);
            if (response.status === 200) {
                setProductConfig(response.data);
                return response.data;
            } else {
                throw new Error(`Unexpected status code: ${response.status}`);
            }
        } catch (error) {
            console.error("API call failed:", error);
            throw error;
        }
    }
);

export const createProductConfig = createAsyncThunk(
    "productConfig/createProductConfig",
    async (payload) => {
        try {
            const response = await api.productConfig.createProductConfig(payload);
            if (response.status === 201) {
                return response.data;
            } else {
                throw new Error(`Unexpected status code: ${response.status}`);
            }
        } catch (error) {
            console.error("API call failed:", error);
            throw error;
        }
    }
);

const productConfigSlice = createSlice({
    name: "productConfigSlice",
    initialState,
    reducers: {
        setProductConfig: (state, action) => {
            state.productConfig = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getGenericProducts.pending, (state) => {
                console.log("pending");
            })
            .addCase(getGenericProducts.fulfilled, (state, action) => {
                console.log(action.payload, "response");
                state.genericProducts = action.payload;
            })
            .addCase(getGenericProducts.rejected, (state, action) => {
                state.genericProducts = [];
                console.log("rejected", action.error.message);
            })



    },
});

export const { setProductConfig } = productConfigSlice.actions;

export default productConfigSlice.reducer;
